import {endsWith, startsWith, includes} from 'lodash';

class DatatableSearchExpressionService {

    static isStringRangeExpression(searchFilter: DisguiseDto.SearchValues,
                                   datatype: DisguiseDto.EnumDataType) {
        const isNumberType = datatype === 'NUMBER';
        return !searchFilter.equal && (searchFilter.min || searchFilter.max) && !isNumberType;
    }

    static stringLikeExpressionMatches(currentSearchValue: DisguiseDto.SearchValues, currentCellValue: string) {
        let comparisonResult = false;

        const searchString = (currentSearchValue.equal || '').toLowerCase();
        if (currentSearchValue.relationalOperator === 'EQUALS') {
            comparisonResult = currentCellValue.toLowerCase().indexOf(searchString) > -1;
        } else if (currentSearchValue.relationalOperator === 'LESS_THAN') {
            comparisonResult = currentCellValue.toLowerCase() < searchString;
        } else if (currentSearchValue.relationalOperator === 'GREATER_THAN') {
            comparisonResult = currentCellValue.toLowerCase() > searchString;
        } else if (currentSearchValue.relationalOperator === 'GREATER_THAN_OR_EQUAL_TO') {
            comparisonResult = currentCellValue.toLowerCase() >= searchString;
        } else if (currentSearchValue.relationalOperator === 'LESS_THAN_OR_EQUAL_TO') {
            comparisonResult = currentCellValue.toLowerCase() <= searchString;
        } else if (currentSearchValue.relationalOperator === 'STARTS_WITH') {
            comparisonResult = startsWith(currentCellValue.toLowerCase(), searchString);
        } else if (currentSearchValue.relationalOperator === 'ENDS_WITH') {
            comparisonResult = endsWith(currentCellValue.toLowerCase(), searchString);
        } else if (currentSearchValue.relationalOperator === 'LIKE') {
            comparisonResult = includes(currentCellValue.toLowerCase(), searchString);
        }

        if (currentSearchValue.negate) {
            comparisonResult = !comparisonResult;
        }

        return comparisonResult;
    }

    static numberExpressionMatches(currentSearchValue: DisguiseDto.SearchValues, currentCellValue: number) {
        let comparisonResult = false;

        if (currentSearchValue.relationalOperator === 'EQUALS') {
            comparisonResult = currentCellValue === Number(currentSearchValue.equal);
        } else if (currentSearchValue.relationalOperator === 'LESS_THAN') {
            comparisonResult = currentCellValue < Number(currentSearchValue.equal);
        } else if (currentSearchValue.relationalOperator === 'GREATER_THAN') {
            comparisonResult = currentCellValue > Number(currentSearchValue.equal);
        } else if (currentSearchValue.relationalOperator === 'GREATER_THAN_OR_EQUAL_TO') {
            comparisonResult = currentCellValue >= Number(currentSearchValue.equal);
        } else if (currentSearchValue.relationalOperator === 'LESS_THAN_OR_EQUAL_TO') {
            comparisonResult = currentCellValue <= Number(currentSearchValue.equal);
        } else if (currentSearchValue.relationalOperator === 'STARTS_WITH') {
            comparisonResult = startsWith(String(currentCellValue), currentSearchValue.equal);
        } else if (currentSearchValue.relationalOperator === 'ENDS_WITH') {
            comparisonResult = endsWith(String(currentCellValue), currentSearchValue.equal);
        } else if (currentSearchValue.relationalOperator === 'LIKE') {
            comparisonResult = includes(String(currentCellValue), currentSearchValue.equal);
        }

        if (currentSearchValue.negate) {
            comparisonResult = !comparisonResult;
        }

        return comparisonResult;
    }

    static numberRangeExpressionMatches(currentSearchValue: DisguiseDto.SearchValues,
                                        currentCellValueNumber: number) {
        let result = false;
        if (currentSearchValue.min && currentSearchValue.max) {
            const minSearchValueNumber = Number(currentSearchValue.min);
            const maxSearchValueNumber = Number(currentSearchValue.max);
            if (currentSearchValue.negate) {
                result = (currentCellValueNumber < minSearchValueNumber
                    || currentCellValueNumber > maxSearchValueNumber);
            } else {
                result = (currentCellValueNumber >= minSearchValueNumber
                    && currentCellValueNumber <= maxSearchValueNumber);
            }
        } else if (currentSearchValue.min) {
            const minSearchValueNumber = Number(currentSearchValue.min);
            if (currentSearchValue.negate) {
                result = currentCellValueNumber < minSearchValueNumber;
            } else {
                result = currentCellValueNumber >= minSearchValueNumber;
            }
        } else if (currentSearchValue.max) {
            const maxSearchValueNumber = Number(currentSearchValue.max);
            if (currentSearchValue.negate) {
                result = currentCellValueNumber > maxSearchValueNumber;
            } else {
                result = currentCellValueNumber <= maxSearchValueNumber;
            }
        }
        return result;
    }
}

export {DatatableSearchExpressionService};
